import { Component} from '@angular/core';
import { AppComponent } from "../app.component";
import { DivisionChartJsResponse,RPTApiService } from '../API/rptapi.service';

@Component({
  selector: 'DashBoardDetails',
  templateUrl: './DashBoardDetails.component.html',
 styleUrls: ['./DashBoardDetails.css'],
}) 

  

export class DashBoardDetailsComponent {
    
      
    basicData: any;
    basicOptions: any;
    data: any;
    options1: any;
    bardata: any;
    baroptions: any;
    monthlyTaskData: any;
    monthlyTaskOptions: any;
    monthlyRepairCostData: any;
    monthlyRepairCostOptions: any;
    current_date;
    today = new Date();
    currentMonth = (this.today.getUTCMonth() + 1);
    currentYear = this.today.getUTCFullYear();
  MonthList = [
    { value: '1', text: 'January' },
    { value: '2', text: 'February' },
    { value: '3', text: 'March' },
    { value: '4', text: 'April' },
    { value: '5', text: 'May' },
    { value: '6', text: 'June' },
    { value: '7', text: 'July' },
    { value: '8', text: 'August' },
    { value: '9', text: 'September' },
    { value: '10', text: 'October' },
    { value: '11', text: 'November' },
    { value: '12', text: 'December' }
  ];
  YearList = [];
    constructor(
    
    private rptapi: RPTApiService,
    
  ) { }

    ngOnInit() {
        let year = (new Date().getFullYear() );

        for (var i = 2019; i <= year; i++) {
        this.YearList.push({ value: i.toString(), text: i.toString() });
        }
        this.current_date = new Date();
        this.currentMonth =this.current_date.getMonth() + 1;
        this.currentYear=this.current_date.getFullYear();
        this.loadChart();
        
        // const documentStyle = getComputedStyle(document.documentElement);
        // const textColor = documentStyle.getPropertyValue('--text-color');
        // const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        // const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        
        // this.bardata = {
        //     labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        //     datasets: [
        //         {
        //             type: 'bar',
        //             label: 'Incidents',
        //             backgroundColor: documentStyle.getPropertyValue('--blue-500'),
        //             data: [50, 25, 12, 48, 90, 76, 42]
        //         },
        //         {
        //             type: 'bar',
        //             label: 'Repairs',
        //             backgroundColor: documentStyle.getPropertyValue('--green-500'),
        //             data: [21, 84, 24, 75, 37, 65, 34]
        //         },
        //         {
        //             type: 'bar',
        //             label: 'PMs',
        //             backgroundColor: documentStyle.getPropertyValue('--yellow-500'),
        //             data: [41, 52, 24, 74, 23, 21, 32]
        //         }
        //     ]
        // };

        // this.baroptions = {
        //     maintainAspectRatio: false,
        //     aspectRatio: 0.8,
        //     plugins: {
        //         tooltip: {
        //             mode: 'index',
        //             intersect: false
        //         },
        //         legend: {
        //             labels: {
        //                 color: textColor
        //             }
        //         }
        //     },
        //     scales: {
        //         x: {
        //             stacked: true,
        //             ticks: {
        //                 color: textColorSecondary
        //             },
        //             grid: {
        //                 color: surfaceBorder,
        //                 drawBorder: false
        //             }
        //         },
        //         y: {
        //             stacked: true,
        //             ticks: {
        //                 color: textColorSecondary
        //             },
        //             grid: {
        //                 color: surfaceBorder,
        //                 drawBorder: false
        //             }
        //         }
        //     }
        // };

    //      this.basicData = {
    //       labels: ['HOME', 'MAIN', 'EU', 'NU', 'OFFU', 'SU'],
    //     datasets: [
    //     {
    //         label: 'Completed Repairs',
    //     backgroundColor: '#42A5F5',
    //       data: [25, 85, 40, 21, 58, 22]
    //     },
    //     {
    //         label: 'Total Repairs',
    //     backgroundColor: '#FFA726',
    //       data: [35, 90, 45, 50, 65, 42]
    //     },
    // ]
    //     };

    //    this.basicOptions = {
    //     plugins: {
    //         legend: {
    //             labels: {
    //                 color: textColor
    //             }
    //         }
    //     },
    //     scales: {
    //         y: {
    //             beginAtZero: true,
    //             ticks: {
    //                 color: textColorSecondary,
    //                 callback: function (value) {
    //                     return value;
    //                 }
    //             },
    //             grid: {
    //                 color: surfaceBorder,
    //                 drawBorder: false
    //             }
    //         },
    //         x: {
    //             ticks: {
    //                 color: textColorSecondary
    //             },
    //             grid: {
    //                 color: surfaceBorder,
    //                 drawBorder: false
    //             }
    //         }
    //     }
    //     };
        
    //     this.monthlyTaskData = {
    //     labels: ['HOME', 'MAIN', 'EU', 'NU', 'OFFU', 'SU'],
    //     datasets: [
    //     {
    //         label: 'In Progress Tasks',
    //         backgroundColor: documentStyle.getPropertyValue('--blue-500'),
    //         borderColor: documentStyle.getPropertyValue('--blue-500'),
    //         data: [25, 8, 22, 20, 26, 38, 35]
    //     },
    //     {
    //         label: 'Completed Tasks',
    //         backgroundColor: documentStyle.getPropertyValue('--pink-500'),
    //         borderColor: documentStyle.getPropertyValue('--pink-500'),
    //         data: [28, 35, 30, 25, 45, 48, 55]
    //     },
    // ]
    //     };

    
 
        // this.monthlyRepairCostData = {
        //     labels: ['HOME', 'MAIN', 'EU', 'NU', 'OFFU', 'SU'],
        //     datasets: [
        //         {
        //             label: 'Parts Cost',
        //             data: [5000, 7500, 12800, 9700, 11000,15000,8000],
        //             backgroundColor: ['rgba(255, 159, 64, 0.2)', 'rgba(75, 192, 192, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(153, 102, 255, 0.2)'],
        //             borderColor: ['rgb(255, 159, 64)', 'rgb(75, 192, 192)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)'],
        //             borderWidth: 1
        //         }
        //     ]
        // };

        
    //console.log(this.current_date.getMonth());
    
    }

    loadChart() {
        AppComponent.ShowLoader();
        //task chart
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        var loadChart1=false,loadChart2=false,loadChart3=false,loadChart4=false;
  this.rptapi.getDivisionChart(this.currentMonth, this.currentYear).subscribe((res: DivisionChartJsResponse) => {
    this.monthlyTaskData = {
      labels: res.labels,
      datasets: res.datasets
    };

        this.monthlyTaskOptions = {
            // Change here (or remove indexAxis altogether)
            indexAxis: 'x', 
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        }
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };
        loadChart1=true;
        if(loadChart1 && loadChart2 && loadChart3 && loadChart4)
        {
            AppComponent.HideLoader();
        }
  });

  //parts cost
  const monthYear = this.toMonthYear(this.currentMonth, this.currentYear);
  this.rptapi.getMonthlyPartsCost(monthYear).subscribe(res => {

  this.monthlyRepairCostData = {
    labels: res.labels,
    datasets: [
      {
        label: res.dataset.label,
        data: res.dataset.data,
        backgroundColor: [
          '#ffedd5', '#d1fae5', '#dbeafe',
          '#ede9fe', '#ffedd5', '#ecfeff'
        ],
        borderColor: [
          '#fb923c', '#10b981', '#3b82f6',
          '#8b5cf6', '#fb923c', '#06b6d4'
        ],
        borderWidth: 1
      }
    ]
  };

  this.monthlyRepairCostOptions = {
    plugins: {
        legend: {
            labels: {
                color: textColor
            }
        },
        tooltip: {
            callbacks: {
                label: function (context) {
                    const label = context.dataset.label || '';
                    const value = context.parsed.y !== undefined ? context.parsed.y : context.parsed;
                    return `${label}: $${value}`;
                }
            }
        }
    },
    scales: {
        y: {
            beginAtZero: true,
            ticks: {
                color: textColorSecondary,
                callback: function (value) {
                    return `$${value}`;
                }
            },
            grid: {
                color: surfaceBorder,
                drawBorder: false
            }
        },
        x: {
            ticks: {
                color: textColorSecondary
            },
            grid: {
                color: surfaceBorder,
                drawBorder: false
            }
        }
    }
};  
loadChart2=true;
        if(loadChart1 && loadChart2 && loadChart3 && loadChart4)
        {
            AppComponent.HideLoader();
        }
});
//repairs
this.rptapi.getMonthlyRepairChart(monthYear).subscribe(res => {

  this.basicData = {
      labels: res.labels,
      datasets: [
        {
          label: 'Completed Repairs',
          backgroundColor: '#3b82f6',
          data: res.completed
        },
        {
          label: 'Total Repairs',
          backgroundColor: '#f59e0b',
          data: res.total
        }
      ]
    };

  this.basicOptions = {
        plugins: {
            legend: {
                labels: {
                    color: textColor
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: textColorSecondary,
                    callback: function (value) {
                        return value;
                    }
                },
                grid: {
                    color: surfaceBorder,
                    drawBorder: false
                }
            },
            x: {
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder,
                    drawBorder: false
                }
            }
        }
        };
        loadChart3=true;
        if(loadChart1 && loadChart2 && loadChart3 && loadChart4)
        {
            AppComponent.HideLoader();
        }
});
//home program
this.rptapi.getHomeTypeChartCount(monthYear).subscribe(res => {

  this.bardata = {
      labels: res.Labels ?? res.labels,
      datasets: [
        {
          label: 'Incidents',
          data: res.Incidents ?? res.incidents,
          backgroundColor: '#3b82f6'
        },
        {
          label: 'Repairs',
          data: res.Repairs ?? res.repairs,
          backgroundColor: '#22c55e'
        },
        {
          label: 'PMs',
          data: res.PMs ?? res.pMs,
          backgroundColor: '#eab308'
        }
      ]
    };

  this.baroptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                tooltip: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                },
                y: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };
        loadChart4=true;
        if(loadChart1 && loadChart2 && loadChart3 && loadChart4)
        {
            AppComponent.HideLoader();
        }
});
}


 toMonthYear(month: number, year: number): string {
  const mm = month.toString().padStart(2, '0');
  return `${mm}-${year}`;
}

prevMonth() {
  
  if (this.currentMonth === 1) {
    this.currentMonth = 12;
    this.currentYear--;
  } else {
    this.currentMonth--;
  }
  console.log(this.currentMonth);
  this.current_date = new Date(this.currentYear, this.currentMonth-1, 1);
  console.log(this.current_date);
  this.loadChart();
}

nextMonth() {
  // Optional: block future months
  const now = new Date();
  const next = new Date(this.currentYear, this.currentMonth, 1);
  
  if (next > new Date(now.getFullYear(), now.getMonth(), 1)) return;

  if (this.currentMonth === 12) {
    this.currentMonth = 1;
    this.currentYear++;
  } else {
    this.currentMonth++;
  }
  this.current_date = new Date(this.currentYear, this.currentMonth-1, 1);
  this.loadChart();
}

isNextDisabled(): boolean {
    const now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), 1);
  return (
   
    this.current_date.getFullYear() === today.getFullYear() &&
    this.current_date.getMonth() === today.getMonth()
  );
}
    getColor(index: number): string {
        const fallbackColors = [
        '#42A5F5', '#66BB6A', '#FFA726', '#26C6DA', '#7E57C2', '#FF7043', '#D4E157'
        ];
        return fallbackColors[index % fallbackColors.length];
    }

    onMonthYearChange() {
        this.current_date = new Date(this.currentYear, this.currentMonth-1, 1);
        this.loadChart();
  }
}
